import { AppointmentRepository } from '../contracts/repositories';
import { Appointment } from '../entities';

export class AppointmentService {
  constructor(private readonly appointmentRepository: AppointmentRepository) {}

  async listAll(): Promise<Appointment[]> {
    return await this.appointmentRepository.findAll();
  }

  async create(appointment: Appointment): Promise<void> {
    await this.appointmentRepository.create(appointment);
  }

  async listByDoctor(doctorId: string, fromNow?: boolean): Promise<Appointment[]> {
    return await this.appointmentRepository.findByDoctor({ doctorId, fromNow });
  }
}
